import { render, staticRenderFns } from "./i-msg-record.vue?vue&type=template&id=07710de8&scoped=true"
import script from "./i-msg-record.vue?vue&type=script&lang=js"
export * from "./i-msg-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07710de8",
  null
  
)

export default component.exports